const AuthenticationActions = {
    Unauthorized: "AUTHENTICATIONACTIONS.UNAUTHORIZED",
    Unauthenticated: "AUTHENTICATIONACTIONS.UNAUTHENTICATED",
};

module.exports = AuthenticationActions;


// WEBPACK FOOTER //
// ./src/actions/AuthenticationActions.js